import PropTypes from "prop-types";
import React from "react";
import Button from "@material-ui/core/Button";
import { Trans } from "@lingui/macro";
import Icon from "@material-ui/core/Icon";
import { getCurrentStep, getReturnedValue } from "../utils/fetcher";
import { searchStep } from "../utils/scenario-manager";
import { store } from "../store";
import { handleContinueFooter } from "../actions";
import { connect } from "react-redux";
import { Component } from "react";

class Footer extends Component {
  render() {
    const { isFirstStep, previousStep, continueName } = this.props;
    const oqid = getReturnedValue("originalQuestionId", "");
    const qid = getReturnedValue("idquestion", "");
    const currentStep =
      searchStep(store.getState().steps, getCurrentStep()) || {};
    const hasQuestions = !(oqid === "" && qid === "");
    let isEnablePrev = isFirstStep;
    if (hasQuestions && currentStep.code === "question") {
      isEnablePrev = hasQuestions && oqid === qid;
    }
    if (currentStep?.code === "summary") {
      isEnablePrev = true;
    }
    return (
      <footer className="footer-main">
        <div>
          {!isEnablePrev && (
            <Button
              disabled={isEnablePrev}
              onClick={previousStep}
              className="btn"
              color="primary"
              style={{ transform: "translateY(-1cm)" }}
            >
              <Icon color="primary">arrow_back</Icon>
              <span className="text">
                <Trans id={"W_STEP_BOUTON_RETOUR"} />
              </span>
            </Button>
          )}
        </div>
        <div>
          {this.props.showFooterContinue && (
            <Button
              onClick={this.props.footerHandler}
              className="btn-filled"
              disabled={this.props.continueDisabled}
              color="primary"
              variant="contained"
            >
              <span className="text">
                {!continueName && <Trans id={"W_STEP_BOUTON_CONTINUER"} />}
              </span>
              <Icon>arrow_forward</Icon>
            </Button>
          )}
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  continueDisabled: PropTypes.bool,
  continueName: PropTypes.any,
  footerHandler: PropTypes.func,
  isFirstStep: PropTypes.bool,
  previousStep: PropTypes.func,
  showFooterContinue: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    footerHandler: state.showFooterContinue.handle,
    showFooterContinue: state.showFooterContinue.value,
    continueDisabled: state.showFooterContinue.disabled
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleContinueFooter: handler => dispatch(handleContinueFooter(handler))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
